import * as actions from './mobileNavActions';

const mobileNavReducers = {
  [actions.MOBILE_NAV_TOGGLE]: (state, { payload }) => {
    state.isActive = payload;
    return state;
  },
};

export default {
  name: 'mobileNav',
  reducers: mobileNavReducers,
};
